<template>
  <div :class="$style['home']">
    <SiteHeader :state="headerState" tickets-to="#avond" :solid-on-scroll="false" />
    <main>
      <HomeStage
        :title="show.title"
        kicker="De nieuwe Hengelose Revue"
        :when="show.when"
        :where="show.where"
        :logo="SHOW_LOGO"
        @state="state => headerState = state === 'closed' ? 'hidden' : 'visible'" />
      <HomeTapes
        :amber="[show.title, show.whenLong, 'Schouwburg Hengelo']"
        :red="['Dé hilarische theatervoorstelling in Twente', 'Komedie, muziek en dans', 'Sinds 1953']" />
      <HomePoster :title="show.title" :when="show.whenLong" :logo="SHOW_LOGO" :poster="SHOW_POSTER" />
      <SiteDates :performances="show.performances" :photos="SHOW_PEEK_PHOTOS" />
      <HomeReel
        title="Een avond vol humor, muziek en dans"
        text="Gemaakt en gespeeld door mensen uit Hengelo en omgeving. Voor alle leeftijden."
        :photos="SHOW_REEL_PHOTOS" />
      <HomeYears :year="show.year" :title="show.title" />
      <SiteSponsorMarquee />
      <HomeFinale :performances="show.performances" :where="show.where" />
    </main>
    <SiteFooter />
    <HomeSpotlight />
  </div>
</template>
<script setup lang="ts">
// Imported here on purpose: auto-imports skip SHOW_POSTER
import { SHOW_LOGO, SHOW_POSTER } from '~/utils/show'

const props = defineProps({ blok: Object })

const headerState = ref<'css' | 'hidden' | 'visible'>('css')

const { formatHome, formatBreadcrumbs } = useHrMeta()
const show = await useShow()
if (show.stories.length) {
  formatHome({ title: props.blok?.title, description: props.blok?.description, events: show.stories })
}
formatBreadcrumbs()
</script>
<style module>
.home {
  background: var(--stage-black);
  color: var(--stage-white);
}
</style>
